import * as fromDataType from '../datatype-library/index'

export interface app_perm_template_request_hdr_RowInterface {
    guid: fromDataType.GuidDataFieldInterface;
    namespace: fromDataType.VarcharDatatypeInterface;
    applet_guid: fromDataType.GuidDataFieldInterface;
    applet_version: fromDataType.VarcharDatatypeInterface;
    applet_topic: fromDataType.TextDatatypeInterface;
    module_guid: fromDataType.GuidDataFieldInterface;
    type: fromDataType.VarcharDatatypeInterface;
    code: fromDataType.VarcharDatatypeInterface;
    name: fromDataType.VarcharDatatypeInterface;
    description: fromDataType.TextDatatypeInterface;
    operation_options_json: fromDataType.JsonDatatypeInterface;
    operation_default_json: fromDataType.JsonDatatypeInterface;
    property_json: fromDataType.JsonDatatypeInterface;
    created_by_subject_guid: fromDataType.GuidDataFieldInterface;
    updated_by_subject_guid: fromDataType.GuidDataFieldInterface;
    created_date: fromDataType.TimestampTzDatatypeInterface;
    updated_date: fromDataType.TimestampTzDatatypeInterface;
    status: fromDataType.VarcharDatatypeInterface;
    revision: fromDataType.GuidDataFieldInterface;
    vrsn: fromDataType.VarcharDatatypeInterface;
    status_request: fromDataType.VarcharDatatypeInterface;
}

export class app_perm_template_request_hdr_RowClass implements app_perm_template_request_hdr_RowInterface {
    guid: fromDataType.GuidDataFieldInterface;
    namespace: fromDataType.VarcharDatatypeInterface;
    applet_guid: fromDataType.GuidDataFieldInterface;
    applet_version: fromDataType.VarcharDatatypeInterface;
    applet_topic: fromDataType.TextDatatypeInterface;
    module_guid: fromDataType.GuidDataFieldInterface;
    type: fromDataType.VarcharDatatypeInterface;
    code: fromDataType.VarcharDatatypeInterface;
    name: fromDataType.VarcharDatatypeInterface;
    description: fromDataType.TextDatatypeInterface;
    operation_options_json: fromDataType.JsonDatatypeInterface;
    operation_default_json: fromDataType.JsonDatatypeInterface;
    property_json: fromDataType.JsonDatatypeInterface;
    created_by_subject_guid: fromDataType.GuidDataFieldInterface;
    updated_by_subject_guid: fromDataType.GuidDataFieldInterface;
    created_date: fromDataType.TimestampTzDatatypeInterface;
    updated_date: fromDataType.TimestampTzDatatypeInterface;
    status: fromDataType.VarcharDatatypeInterface;
    revision: fromDataType.GuidDataFieldInterface;
    vrsn: fromDataType.VarcharDatatypeInterface;
    status_request: fromDataType.VarcharDatatypeInterface;
}